<cs-challenge-day-cycle-selector
  [displayText]="dayDisplayText()"
  [animationKey]="selectedCycleDayMoment()?.valueOf()"
  [prevDisabled]="isPrevDayDisabled()"
  [nextDisabled]="isNextDayDisabled()"
  [loadingDirection]="loadingDirection()"
  (prev)="onPrevDay()"
  (next)="onNextDay()"
></cs-challenge-day-cycle-selector>

<div class="tasks-content" [@slideContent]="selectedCycleDayMoment()?.valueOf()">
  @if (charts()?.length > 0) {
    <div
      class="charts-scroll-wrapper"
      [class.fade-right]="scrollFade() === 'right'"
      [class.fade-left]="scrollFade() === 'left'"
      [class.fade-both]="scrollFade() === 'both'"
    >
      <div class="charts-container" #chartsScroll (scroll)="onChartsScroll()">
        @for (chart of charts(); track chart.name) {
          <button type="button" class="chart-tile" (click)="openChartDetailDialog(chart)">
            @if (
              chartDetailLoadingMap()[selectedCycleDayDateKey()]?.[chart._id] &&
              !chartDetailMap()[selectedCycleDayDateKey()]?.[chart._id]
            ) {
              <div class="chart-tile-loading" aria-hidden="true">
                <mat-spinner class="chart-tile-spinner" diameter="32" />
              </div>
            }
            <div class="chart-name">{{ chart.name }}</div>
            <div class="chart-meter" [style.--chart-progress-color]="chartProgressColorMap().get(chart.name)">
              <svg viewBox="0 0 80 80">
                <circle class="track" cx="40" cy="40" r="36" />
                <circle
                  class="progress"
                  cx="40"
                  cy="40"
                  r="36"
                  transform="rotate(-90 40 40)"
                  [attr.stroke-dasharray]="circumference"
                  [attr.stroke-dashoffset]="chartDashOffsetMap().get(chart.name)"
                />
              </svg>
              @if (chartCompletionMap().get(chart.name)) {
                <div class="chart-complete">
                  <mat-icon svgIcon="check" class="chart-complete-icon" />
                </div>
              } @else {
                <div class="chart-values">
                  <span class="current-value">{{
                    chart.type === 'duration'
                      ? (chart.currentValue | trackerMetricValue: 'duration')
                      : chart.currentValue
                  }}</span>
                  <span class="target-value">{{
                    chart.type === 'duration' ? (chart.targetValue | trackerMetricValue: 'duration') : chart.targetValue
                  }}</span>
                </div>
              }
            </div>
          </button>
        }
      </div>
    </div>
  }

  @if (tasks()?.length > 0) {
    <div class="tasks-container">
      @for (task of tasks(); track task._id) {
        <button
          type="button"
          class="task-card task-card--button"
          [class.task-card--completed]="isCompleted(task)"
          [disabled]="areTasksDisabled()"
          (click)="openMetricUpdateDialog(task)"
        >
          <img class="task-icon" [src]="'assets/img/icons/color-icons/' + task.icon + '.svg'" [alt]="task.label" />
          <span class="task-name">{{ task.label }}</span>
          @if (task.status === TaskStatuses.InProgress && task.schedule !== 'multiple') {
            <div class="task-checked-badge">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path
                  d="M2 7.5L5.5 11L12 4"
                  stroke="#5acd52"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          } @else {
            <cb-schedule-chip
              class="task-schedule-chip"
              [type]="getScheduleType(task.schedule)"
              [iconOnly]="true"
              [hideBorder]="true"
            />
          }
        </button>
      }
    </div>
  }
</div>
